import AbstractFilter from '@/classes/filters/AbstractFilter'

export default class CheckboxFilter extends AbstractFilter {
  /**
   * Create new text filter
   *
   * @param {String} key
   * @param {String} label
   * @param {String} property
   * @param {Boolean} [value]
   */
  constructor (key, label, property, checkedValue = true, uncheckedValue = false, value = false) {
    super(key, label, property, value)

    this.checkedValue = checkedValue
    this.uncheckedValue = uncheckedValue

    this.type = 'CheckboxFilter'
  }

  /**
   * Does this filter have a value?
   *
   * @return {boolean}
   */
  hasValue () {
    return Boolean(this.value)
  }

  /**
   * Get value of this filter as string
   *
   * @return {String}
   */
  toString () {
    return `${this.value ? this.checkedValue : this.uncheckedValue}`
  }
}
